export default "__VITE_ASSET__B35klrO0__"